import { render, staticRenderFns } from "./CadastroNovidade.vue?vue&type=template&id=0ef47d11&scoped=true&"
import script from "./CadastroNovidade.vue?vue&type=script&lang=js&"
export * from "./CadastroNovidade.vue?vue&type=script&lang=js&"
import style0 from "./CadastroNovidade.vue?vue&type=style&index=0&id=0ef47d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef47d11",
  null
  
)

export default component.exports